import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getTyreTypes = async () =>
  (await axiosInstance.get(`${API_URL}/tyre-types`)).data;

export const getTyreTypesPaginated = async (params = {}) =>
  (await axiosInstance.get(`${API_URL}/tyre-types/paginated`, { params })).data;

export const getTyreTypeById = async (id) =>
  (await axiosInstance.get(`${API_URL}/tyre-types/${id}`)).data;

export const createTyreType = async (payload) =>
  (await axiosInstance.post(`${API_URL}/tyre-types`, payload)).data;

export const updateTyreType = async (id, payload) =>
  (await axiosInstance.put(`${API_URL}/tyre-types/${id}`, payload)).data;

export const deleteTyreType = async (id) =>
  (await axiosInstance.delete(`${API_URL}/tyre-types/${id}`)).data;
